import { render, staticRenderFns } from "./goodsForm.vue?vue&type=template&id=5614187f&scoped=true"
import script from "./goodsForm.vue?vue&type=script&lang=js"
export * from "./goodsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5614187f",
  null
  
)

export default component.exports